import type { CategoriaForm } from '../api/settings';

export type CategoriaBadgeVariant = 'info' | 'purple' | 'warning' | 'sage';

// Palette deterministica: ogni codice categoria ottiene un colore stabile senza
// bisogno di una mappa hardcoded -> aggiungere una categoria non richiede modifiche qui.
const PALETTE: CategoriaBadgeVariant[] = ['info', 'purple', 'warning', 'sage'];

/** Etichetta visualizzata di una categoria: nome_visualizzato dalla tabella, fallback al codice. */
export function categoriaLabel(codice: string, categorie: CategoriaForm[]): string {
  return categorie.find((c) => c.codice === codice)?.nome_visualizzato ?? codice;
}

// Colori originali (pre-refactor data-driven) dei 4 codici noti, dal vecchio
// categoriaBadge switch: preservati per non cambiare l'aspetto dei badge esistenti.
const VARIANT_NOTI: Record<string, CategoriaBadgeVariant> = {
  pv_pro: 'info',
  pv_dom: 'info',
  serramenti: 'purple',
  cavi: 'warning',
};

/**
 * Variante badge di una categoria. I codici noti mantengono il colore storico;
 * qualunque altro codice ottiene un colore stabile via hash deterministico sulla palette.
 */
export function categoriaVariant(codice: string): CategoriaBadgeVariant {
  const noto = VARIANT_NOTI[codice];
  if (noto) return noto;

  let hash = 0;
  for (let i = 0; i < codice.length; i++) {
    hash = (hash * 31 + codice.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]!;
}
